import React, { Fragment, useEffect, useState } from 'react'
import { apiwebUrl } from '../utils';

function Proveedoreslist() {
    const [proveedor, setProveedor] = useState([]);
    const [cargar, setCargar] = useState(true)

    const traerServi = async() => {
        const url = apiwebUrl + "proveedores.php"
        /*
        fetch(url).then(respuesta => respuesta.json())
            .then(data => {
                setProveedor(data)
                setCargar(false)
            })*/
        const response = await fetch(url)
        const data = await response.json()
        setProveedor(data)
        setCargar(false)
    }

    const mostrarTabla = () => {
        return (
            <div className='table-responsive'>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Codigo</th>
                            <th scope="col">Empresa</th>
                            <th scope="col">Conacto</th>
                            <th scope="col">Pais</th>
                            <th scope="col">Ciudad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            proveedor.map(item => (
                                <tr className="table-active" key={item.idproveedor}>
                                    <th scope="row">{item.idproveedor}</th>
                                    <td>{item.nombreempresa}</td>
                                    <td>{item.nombrecontacto}</td>
                                    <td>{item.pais}</td>
                                    <td>{item.ciudad}</td>
                                </tr>

                            ))
                        }
                    </tbody>
                </table>
            </div>

        )
    }

    const loader = () => {
        return (
            <div className="spinner">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
            </div>
        )
    }
    useEffect(() => {
        traerServi()
    }, [])
    return (
        <Fragment>
            <div className='container-fluid mt-5'>
                <h4 className='fw-light'>Nuestras empresas de envios</h4>
                <div className='d-flex justify-content-between'>
                    {
                        cargar ? loader() : mostrarTabla()
                    }
                </div>
            </div>
        </Fragment >
    )
}

export default Proveedoreslist